import comboComponent from "@/components/child/form/combo.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import VisitadorModel from "@/models/visitadorModel";
import VisitadorService from "@/services/visitadorService";
import Delay from "@/utils/common/delay";

import ListComponentBase from "../listComponentBase";

const visitadorService = new VisitadorService();

@Component({
    components: {
        shortcutComponent,
        comboComponent,
    },
})
export default class VisitadorListComponent extends ListComponentBase<VisitadorModel> {
    private shortCutComponent: ShortcutComponent = null;

    visitadoresOptions: Array<Object> = [];
    visitadorOrigemId: number = null;
    visitadorDestinoId: number = null;

    private beforeMount() {
        this.setProps(new VisitadorService(), "visitador", "nome");
    }

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("nome", "Nome", GridColumnType.String, false, false, "", "", true),
            new GridColumn("cpf", "CPF", GridColumnType.String, false, false, "", "", true),
            new GridColumn("celular", "Celular", GridColumnType.String, false, false, "", "", true, false),
        ];
    }

    private async onToggleMigrarPrescritores() {
        const data = await visitadorService.combo().resolveWithJSON<PaginationModel<VisitadorModel>>().withLoading();
        this.visitadoresOptions = data.list.map(item => ({ value: item.id, text: item.nome }));
        while (!this.$refs.shortCutComponent) await Delay(50);
        this.shortCutComponent = this.$refs.shortCutComponent as ShortcutComponent;
        this.shortCutComponent.title = this.$t("__.Crud.visitador.list_vue_html.migrarPrescritores") as string;
        this.shortCutComponent.show();
    }

    private async onMigrarPrescritores() {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
            const response = await this.$showQuestion(
                this.$t("__.ts.atencao"),
                this.$t("__.ts.migrarConfirmacaoVisitadores"),
            );
            if (response) {
                try {
                    await visitadorService
                        .transferirPrescritores(this.visitadorOrigemId, this.visitadorDestinoId)
                        .withLoading();
                    this.shortCutComponent.hide();
                    this.$notifySuccess("Os prescritores foram transferidos com sucesso!", this.$t("__.ts.sucesso"));
                } catch {}
            }
        }
    }
}
